/**
 * Applies merchandising display names & values to product pricing attributes
 * in a line item. Assumes the `name` field of a pricing attribute
 * is a single string with key delimited via `:` from value, and that
 * merchandising attributes `key` field matches the first part of the
 * pricing attribute `name` field.  Does not modify original data. If
 * no merchandising entry with a matching key exists, a copy of the original
 * pricing attribute is returned unchanged.
 *
 * @returns New pricing data object (i.e., `lineItem.pricingData`), or if there was no
 * merchandising attribute data, the (unmodified) original pricing data object.
 *
 * */
export const applyLineItemMerchAttrNames = lineItem => {
  const merchAttrs = lineItem.merchandisingData
    ? lineItem.merchandisingData.productAttributes
    : [];
  const { pricingData } = lineItem;
  const pricingAttrs = pricingData ? pricingData.components : [];
  if (pricingAttrs && merchAttrs) {
    const newPricingAttrs = [];
    pricingAttrs.forEach(pa => {
      const newP = { ...pa };
      const pricingKey = pa.name.split(':')[0] || pa.name;
      merchAttrs.forEach(ma => {
        if (pricingKey === ma.key) {
          newP.pricingAttributeName = pa.name;
          // Use merchandising display name if we have it, otherwise fallback to default priced attribute name
          if (ma.keyDisplayName && ma.valueDisplayName) {
            newP.name = `${ma.keyDisplayName}: ${ma.valueDisplayName}`;
          }
        }
      });
      newPricingAttrs.push(newP);
    });
    const newPricingData = { ...pricingData, components: newPricingAttrs };
    return newPricingData;
  }
  return pricingData;
};
